import React from "react"
import LayoutAlertWrapper from "./LayoutAlertWrapper"
import { useLanguage } from "gatsby-singita-theme/src/context/LanguageContext"
const LodgeAlerts = ({ lodge }) => {
  const lang = useLanguage()
  return (
    lodge.alerts &&
    lodge.alerts.map(alert =>
      lang === "en-US" ? <LayoutAlertWrapper key={alert.id} {...alert} /> : null
    )
  )
}

export default LodgeAlerts
